import {DynFieldData, DynSimpleFieldData, DynSubformFieldData} from '.';
import {Entity} from '../../../core/commons/entity';
import {User} from '../../../core/domain/user';
import {DynForm} from '../meta/dyn-form';
import {DynSubformField} from '../meta/fields/dyn-subform-field';
import {DynFillableTextFieldData} from "./dyn-fillable-text-field-data";

export class DynFormData
    implements Entity {

    public id: number;
    private form: DynForm;
    private values: Array<DynFieldData>;
    private createdBy: User;
    private lastUpdatedBy: User;
    private createdDate: number;
    private lastUpdatedDate: number;

    protected static mapBase(json: any, formData: DynFormData) {
        formData.setId(json.id ? json.id : null);
        formData.setCreatedBy(json.createdBy ? new User(json.createdBy) : null);
        formData.setCreatedDate(json.createdDate ? json.createdDate : null);
        formData.setLastUpdatedBy(json.lastUpdatedBy ? new User(json.lastUpdatedBy) : null);
        formData.setLastUpdatedDate(json.lastUpdatedDate ? json.lastUpdatedDate : null);
    }

    public static toEntity(json: any): DynFormData {
        const formData = new DynFormData();
        this.mapBase(json, formData);
        formData.setForm(json.form ? json.form : null);
        /*
        formData.setForm( json.form ? json.form : null );
        if (json.values) {
            formData.setValues(json.values.map(f => {
                switch (f.type) {
                    case 'simple': return DynSimpleFieldData.toEntity(f);
                    case 'subform': return DynSubformFieldData.toEntity(f);
                }
            }))
        }
        */
        return formData;
    }

    public static toEntityDetail(json: any, form: DynForm): DynFormData {
        const formData = new DynFormData();
        this.mapBase(json, formData);
        formData.setForm(form);
        formData.setValues(json.values.map(v => {
            switch (v.type) {
                case 'simple': return DynSimpleFieldData.toEntity(v, form);
                case 'subform': return DynSubformFieldData.toEntity(v, form);
                case 'fillableText': {
                   /* console.log('v:')
                    console.log(v)
                    console.log('form')
                    console.log(form)*/
                    return DynFillableTextFieldData.toEntity(v, form)};
            }
        }));
        return formData;
    }

    public static createEmpty(form: DynForm): DynFormData {
        //console.log(form);
        const formData = new DynFormData();
        formData.setForm(form);
        formData.setValues(form.getFields().map(field => {
            let fieldData: DynSimpleFieldData | DynSubformFieldData;
            switch (field.getType()) {
                case 'subform':
                    fieldData = new DynSubformFieldData();
                    fieldData.setField(field);
                    (fieldData as DynSubformFieldData)
                        .setValue(DynFormData.createEmpty((field as DynSubformField).getForm()));
                    return fieldData;
                default:
                    fieldData = new DynSimpleFieldData();
                    fieldData.setField(field);
                    return fieldData;
            }
        }));
        return formData;
    }

    public getId(): number {
        return this.id;
    }

    public setId(value: number) {
        this.id = value;
    }

    public getForm(): DynForm {
        return this.form;
    }

    public setForm(value: DynForm) {
        this.form = value;
    }

    public getValues(): Array<DynFieldData> {
        return this.values;
    }

    public setValues(value: Array<DynFieldData>) {
        this.values = value;
    }

    public getCreatedBy(): User {
        return this.createdBy;
    }

    public setCreatedBy(value: User) {
        this.createdBy = value;
    }

    public getLastUpdatedBy(): User {
        return this.lastUpdatedBy;
    }

    public setLastUpdatedBy(value: User) {
        this.lastUpdatedBy = value;
    }

    public getCreatedDate(): number {
        return this.createdDate;
    }

    public setCreatedDate(value: number) {
        this.createdDate = value;
    }

    public getLastUpdatedDate(): number {
        return this.lastUpdatedDate;
    }

    public setLastUpdatedDate(value: number) {
        this.lastUpdatedDate = value;
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/domain/data/dyn-form-data.ts